import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import './assets/base.css'
import axios from 'axios'

// Axios global sozlamalari
const BASE_URL = 'https://avtotesting.uz'

axios.defaults.baseURL = BASE_URL
axios.defaults.timeout = 15000
axios.defaults.headers.common['Content-Type'] = 'application/json'

// Har bir so‘rovga token qo‘shish
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 401 holatini ushlash
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      console.warn('401 Unauthorized → token eskirgan yoki mavjud emas')
    }
    return Promise.reject(error)
  }
)

// Vue ilovasini yaratish
const app = createApp(App)

app.use(store)
app.use(router)
app.use(Antd)

app.config.globalProperties.$axios = axios

app.mount('#app')